<template>
  <UiRow no-gutters align="center" class="flex-nowrap">
    <UiCol cols="auto" class="pl-sm-0">
      <UiText
        variant="body-4"
        color="text-on-dark"
        data-test="header-layout-label"
      >
        {{ label }}
      </UiText>
    </UiCol>

    <UiCol v-if="country && country.flag" cols="auto" class="pl-2 d-flex">
      <img
        :src="country.flag"
        :alt="country.country"
        width="21"
        data-test="header-layout-flag"
        class="flag"
      />
    </UiCol>
  </UiRow>
</template>
<script setup lang="ts">
import { UiCol, UiRow, UiText } from '~/ui';
import { type CurrencyWithFlag } from '~/domains/core';

export interface Props {
  label: string;
  country: CurrencyWithFlag;
}

defineProps<Props>();
</script>

<style lang="scss" scoped>
.flag {
  border-radius: 2px;
}
</style>
